<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('DOMContentLoaded', function () {
    console.log("Script loaded and event listener set");

    const offset = 73; // Adjust this to match your sticky header's height

    // Helper function to scroll to an element with an offset
    function scrollToElementWithOffset(element) {
        if (element) {
            // Calculate the target scroll position
            const targetPosition = element.getBoundingClientRect().top + window.scrollY - offset;

            // Smoothly scroll to the target position
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    // Handle anchor links from the same page
    document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            const targetId = href.split('#')[1]; // Extract the target ID
            const targetElement = document.getElementById(targetId);

            if (href.startsWith('#') || href.startsWith('/#')) {
                // Handle same-page anchors
                if (targetElement) {
                    e.preventDefault(); // Prevent default anchor behavior
                    scrollToElementWithOffset(targetElement); // Scroll to the target

                    // Remove the hash from the URL
                    history.replaceState(null, null, window.location.pathname);
                } else {
                    console.log("Target element not found for ID:", targetId);
                }
            } else {
                // Allow default navigation for cross-page links
                console.log("Cross-page link detected, allowing default behavior:", href);
            }
        });
    });

    // Handle direct hash navigation on page load
    if (window.location.hash) {
        const targetId = window.location.hash.substring(1); // Extract the target ID
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            // Scroll to the target after a slight delay to ensure the DOM is ready
            setTimeout(() => {
                scrollToElementWithOffset(targetElement);

                // Remove the hash from the URL
                history.replaceState(null, null, window.location.pathname);
            }, 100); // Adjust delay if needed
        }
    }
});

